import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container mt-8 !items-start !content-start" }
const _hoisted_2 = { class: "actions-row flex justify-end col-start-1 col-end-13" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "alt-table mobile-preserved fixed-column-1 border-collapse col-start-1 col-end-13 max-w-full"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Proje Adı "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " İşlemler ")
  ])
], -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "py-4 px-8 whitespace-nowrap hover:!bg-gray-100 text-left cursor-pointer w-[95%]" }
const _hoisted_8 = { class: "py-4 px-8 whitespace-nowrap text-left" }
const _hoisted_9 = ["onClick"]

import { useGetAllOMProjects } from '@/composables/omPlatformFunctions';
    import {useRouter} from 'vue-router';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'omProjects',
  setup(__props) {


    const {projects, isLoadingProjects} = useGetAllOMProjects();
    const router = useRouter();

    const navigateToProject = (projectId: string) => {
        router.push(`/om-platform/project?id=${projectId}`)
    }

    const editExistingProject = (projectId: string) => {
        router.push(`/om-platform/project-form?id=${projectId}`)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/om-platform/project-form'))),
        class: "ac-add-button"
      }, [
        _createElementVNode("img", {
          src: require('../../assets/icons/add.png')
        }, null, 8, _hoisted_3),
        _createTextVNode(" Yeni Proje Ekle ")
      ])
    ]),
    (!_unref(isLoadingProjects))
      ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projects), (project) => {
              return (_openBlock(), _createElementBlock("tr", {
                onClick: ($event: any) => (navigateToProject(project.id)),
                key: project.id
              }, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(project.name), 1),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (editExistingProject(project.id)), ["stop"]),
                    class: "ac-table-button hover:bg-black hover:text-white border p-4"
                  }, "Düzenle", 8, _hoisted_9)
                ])
              ], 8, _hoisted_6))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})